// ★ VQ-1 — ENCERRADOS no funil — puro.
//
// "Encerrar" é um MOTIVO QUE ENCERRA gravado como carimbo no lead
// (`desfechoNegativoEm`, VG); a etapa continua sendo a coluna de "não" em que o
// lead estava. No funil, o encerrado sai da coluna da etapa e vai para uma coluna
// própria no fim, RECOLHIDA por padrão, agrupada por motivo. Na lista, um filtro
// "Mostrar encerrados" (desligado por padrão).
//
// ⚠ A decisão é SEMPRE pelo carimbo, nunca pela config de motivos: mudar
// `encerra` em Configurações não pode reescrever o funil de ontem.
// ⚠ Este módulo é de TELA. Metas, dashboard e dinheiro seguem lendo o carimbo
// direto (`temDesfechoNegativo` em oportunidade.js) — nenhuma conta muda.

import { CAMPO_MOTIVO, motivoPorId } from '@/leads/motivos';

export const COLUNA_ENCERRADOS = 'encerrados';

const paraData = (v) => {
  if (!v) return null;
  if (typeof v.toDate === 'function') return v.toDate();
  if (v instanceof Date) return Number.isNaN(v.getTime()) ? null : v;
  return null;
};

/** Pelo carimbo. O segundo parâmetro existe só para deixar explícito que a config NÃO entra. */
export const ehEncerrado = (lead, _config = null) => paraData(lead?.desfechoNegativoEm) !== null;

/** A coluna do funil em que o lead aparece: a etapa, ou "encerrados" se carimbado. */
export const colunaDoLead = (lead) => (ehEncerrado(lead) ? COLUNA_ENCERRADOS : lead?.etapa);

/**
 * Os encerrados agrupados por etapa + motivo, maior grupo primeiro. Rótulo pela
 * lista da clínica (config ?? padrão); motivo desconhecido aparece pelo id; sem
 * motivo gravado vira "sem motivo".
 */
export function agruparEncerradosPorMotivo(leads = [], config = null) {
  const grupos = new Map();
  for (const lead of leads ?? []) {
    if (!ehEncerrado(lead)) continue;
    const etapa = lead.etapa ?? '';
    const campo = CAMPO_MOTIVO[etapa];
    const motivoId = (campo && lead[campo]) || '';
    const chave = `${etapa}:${motivoId}`;
    if (!grupos.has(chave)) {
      grupos.set(chave, {
        etapa,
        motivoId,
        rotulo: motivoId ? motivoPorId(config, etapa, motivoId).rotulo : 'sem motivo',
        n: 0,
        leads: [],
      });
    }
    const g = grupos.get(chave);
    g.n += 1;
    g.leads.push(lead);
  }
  return [...grupos.values()].sort((a, b) => b.n - a.n);
}

// ----------------------------------------------- aberto/recolhido por pessoa
// Mesmo desenho de `agenda/preferencias.js`: localStorage COM O UID na chave —
// o computador da recepção é compartilhado.

export const chaveEncerradosAberto = (uid) => `odontosdr:funil-encerrados:${uid ?? 'anonimo'}`;

function deposito() {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}

/** Padrão: RECOLHIDO (false). */
export function carregarEncerradosAberto(uid, armazem = deposito()) {
  try {
    return armazem?.getItem(chaveEncerradosAberto(uid)) === '1';
  } catch {
    return false;
  }
}

export function salvarEncerradosAberto(uid, aberto, armazem = deposito()) {
  if (!armazem) return false;
  try {
    armazem.setItem(chaveEncerradosAberto(uid), aberto ? '1' : '0');
    return true;
  } catch {
    return false;
  }
}
